export default "__VITE_ASSET__CiwkQmJN__"